import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from "@angular/core";
import { ToasterService } from 'angular5-toaster';
import { ModalComponent } from "../modal.component";
import { UserTicket, UserTicketTrip } from "../../core/userTicket";
import { TramApiService } from "../../tram-api.service";
import { TicketActiveTripsPipe, TicketUsedTripsPipe } from "../pipe-index";
import { HttpErrorResponse } from "@angular/common/http";
import * as moment from 'moment';

@Component({
    selector: 'ticket-pass',
    templateUrl: './ticket-pass.component.html',
    styleUrls: ['./ticket-pass.component.scss']
})
export class TicketPassComponent {
    @Input() ticket: UserTicket;
    @Input() mode: 'active' | 'used';

    @Output() trip: UserTicketTrip;
    @Output() opened = new EventEmitter();
    @Output() closed = new EventEmitter();

    @ViewChild('modal') modal: ModalComponent;

    public isLoading: boolean = false;
    public tripAnimate: boolean;
    public isQrVerification: boolean;

    public get tripPassUrl(): string {
        return this.trip ? this.api.getTripPassUrl(this.ticket.id, this.trip.id) : '';
    } 

    public displayingTrips: UserTicketTrip[] = [];
    public activeTripIndex: number;

    constructor(private api: TramApiService,
        private toaster: ToasterService) {
    }

    public open() {
        this.isQrVerification = false;
        if (this.ticket) {
            this.processTicket();
        }

        this.modal.open();
    }

    public get canActivate() {
        return this.ticket && this.ticket.remainingTripsCount > 0;
    }

    public showNextActiveTrip(direction: number) {
        this.showActiveTrip(this.activeTripIndex + direction);
    }

    public generate() {
        this.isLoading = true;

        this.api.createTripWithTicket(this.ticket.id, new Date())
            .then(trip => {
                this.isLoading = false;
                this.selectTrip(trip);
                this.displayingTrips.push(trip);
                this.ticket.remainingTripsCount--;

                this.toaster.pop('success', null, 'Поездка создана');                
            })
            .catch(err => this.handleError(err));
    }

    private processTicket() {
        this.displayingTrips = this.mode === 'active'
            ? new TicketActiveTripsPipe().transform(this.ticket.trips)
            : new TicketUsedTripsPipe().transform(this.ticket.trips);

        const hasTrips = !!this.displayingTrips.length;

        if (hasTrips) {
            this.showActiveTrip();
        } else {
            this.selectTrip(null);
        }

        if (this.canActivate && !hasTrips) {
            this.generate();
        }
    }

    private showActiveTrip(index: number = null) {
        if (index == null || index > this.displayingTrips.length - 1) {
            this.activeTripIndex = 0;
        } else if (index < 0) {
            this.activeTripIndex = this.displayingTrips.length - 1
        } else {
            this.activeTripIndex = index;
        }

        this.selectTrip(this.displayingTrips[this.activeTripIndex]);
    }

    private selectTrip(trip: UserTicketTrip = null) {
        this.isQrVerification = false;
        this.trip = trip;

        if (!trip) {
            this.tripAnimate = false;
        } else {
            this.tripAnimate = false;
            setTimeout(() => this.tripAnimate = true, 100);
        }
    }

    private handleError(error: HttpErrorResponse | string) {
        this.isLoading = false;
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/ticket/ticket-pass.component.ts